import useWindowSize from '../../hooks/useWindowSize'

const FooterAwards = () => {
  const {isMobileDevice} = useWindowSize()

  const awards = [
    {id: 'banking-tech-awards', img: 'logo-recognition-ff.svg', alt: 'FF - Banking Tech Awards'},
    {id: 'european-innovator', img: 'logo-recognition-nominee.svg', alt: 'European Innovator'},
    {id: 'inc-5000-europe', img: 'logo-recognition-inc5000.svg', alt: 'Inc 5000 Europe'},
    {id: 'european-business-awards', img: 'logo-recognition-eba.svg', alt: 'European Business awards'},
    {id: 'respecting-differences', img: 'logo-recognition-respecting-differences.svg', alt: 'Respecting Differences'},
    {id: 'tervist-edendav', img: 'logo-recognition-tervist-edendav.svg', alt: 'Tervist edendav'}
  ]

  return (
    <div className="footer-awards-wrapper">
      <div className="footer-awards-row">
        {awards.slice(0, isMobileDevice ? 3 : 4).map(({id, img, alt}) =>
          <div key={id}>
            <img src={`../images/recognitions/${img}`} alt={`Creditstar award - ${alt}`} />
          </div>
        )}
      </div>
      <div className="footer-awards-row">
        {awards.slice(isMobileDevice ? 3 : 4, 6).map(({id, img, alt}) =>
          <div key={id}>
            <img src={`../images/recognitions/${img}`} alt={`Creditstar award - ${alt}`} />
          </div>
        )}
      </div>
    </div>
  )
}

export default FooterAwards
